<template>
  <div id="home-container" class="container-fluid home-container">
    <div class="accordion" role="tablist">
      <div class="row">
          <b-button id="filterBtn" block v-b-toggle.accordion-1 class="filterBtn">
            <div class="container">
              Filters
              <span class="when-opened">
                  <b-icon icon="x"></b-icon>
              </span>
              <span class="when-closed">
                  <b-icon icon="filter"></b-icon>
              </span>
            </div>
          </b-button>
      </div>
    
    

      <div class="row filter-row">
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel" class="w-100">
        <div class="col-12 mt-4">
          <div class="container p-0">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4 text-left mb-3">
                <!-- make -->
                <label for="make">Make</label>
                <auto-complete :items="makeList" @makeInput="updateMake" ref="autoComplete"></auto-complete>
              </div>
              <div class="col-12 col-md-6 col-lg-4 text-left">
                <!-- year -->
                <label for="year">Year</label>
                <div class="row mb-3">
                  <div class="col">
                    <input id="year" type="number" class="form-control" v-model.number.lazy="yearMin" @blur="updateYearMin">
                  </div>
                  <div class="dash">TO</div>
                  <div class="col">
                    <input type="number" class="form-control" v-model.number.lazy="yearMax" @blur="updateYearMax">
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 text-left">
                <!-- length -->
                <label for="length">Length (ft)</label>
                <div class="row mb-3">
                <div class="col">
                  <input id="length" type="number" class="form-control" v-model.number="lengthMin" @blur="updateLengthMin">
                </div>
                <div class="dash">TO</div>
                <div class="col">
                  <input type="number" class="form-control" v-model.number="lengthMax" @blur="updateLengthMax">
                </div>
                </div>
              </div>
            
              <div class="col-12 col-md-6 col-lg-4 text-left">
                <!-- price -->
                <label for="price">Price ($)</label>
                <div class="row mb-3">
                <div class="col">
                    <div class="row">
                      <div class="col">
                        <money id="price" class="form-control" v-model="priceMin" v-bind="money" @blur.native="updatePriceMin"></money>
                      </div>
                      <div class="dash">TO</div>
                      <div class="col">
                        <money class="form-control" v-model="priceMax" v-bind="money" @blur.native="updatePriceMax"></money>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 text-left">
                <!-- category -->
                <label for="category">Category</label>
                <div class="row text-left mb-3">
                  <div class="col">
                    <select class="form-control" id="category" v-model="category">
                      <option v-for="cat in categoryOptions" :key="cat.text" :value="cat.value">
                        {{ cat.text }} 
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-4 text-left">
                <!-- condition -->
                <label for="condition">Condition</label>
                <div class="row text-left mb-3">
                  <div class="col">
                    <select class="form-control" id="condition" v-model="condition">
                      <option v-for="cond in conditionOptions" :key="cond.text" :value="cond.value">
                        {{ cond.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12 col-md-6 mb-4">
                <button class="btn btn-block btn-secondary btn-reset" @click="resetFilters">Reset Filter</button>
              </div>
              <div class="col-12 col-md-6 mb-3">
                <button class="btn btn-block btn-primary btn-update mb-5" @click="filteredListingsAll" v-b-toggle.accordion-1>Update Results</button>
              </div>
            </div>
          </div>
        </div>
        </b-collapse>
      </div>

    

  </div>


    <div class="row">
      <div class="col-12">
        <listings-container-component :listings="filteredListings" :spinner="spinnerDisplay"></listings-container-component>
      </div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios';
// import vueSlider from 'vue-slider-component'
// @ is an alias to /src
//import FiltersComponent from '@/components/FiltersComponent.vue'
import AutoComplete from '@/components/AutoComplete.vue'
import {Money} from 'v-money';
import ListingsContainerComponent from '@/components/ListingsContainerComponent.vue'
//import FakeHeader from '@/components/FakeHeader.vue'

export default {
  name: 'Home',
  components: {
    //FiltersComponent,
    ListingsContainerComponent,
    AutoComplete,
    Money,
    //FakeHeader
    // vueSlider
  },
  data(){
    return {
      listings: [],
      filteredListings: [],
      listingsLoaded: false,
      make: '',
      makeList: [],
      // year: [1900, new Date().getFullYear()],
      yearMin: 1900,
      yearMax: new Date().getFullYear(),
      minYearAllowed: 1900,
      maxYearAllowed: new Date().getFullYear(),
      // length: [0, 500],
      lengthMin: 0,
      lengthMax: 500,
      lengthMinAllowed: 0,
      lengthMaxAllowed: 500,
      // price: [0, 1000000],
      priceMin: 0,
      priceMax: 10000000,
      minPriceAllowed: 0,
      maxPriceAllowed: 10000000,
      category: null,
      categoryOptions: [],
      condition: '',
      conditionOptions: [
        { text: 'All', value: '' },
        { text: 'New', value: 'new' },
        { text: 'Used', value: 'used' }
      ],
      money: {
          thousands: ',',
          precision: 0,
          masked: false
        },
      spinnerDisplay: true
    }
  },
  computed: {
    // filteredListings() {
    //   return this.filterListingsByPrice(this.filterListingsByLength(this.filterListingsByYear(this.filterListingsByMake(this.listings))))
    // }
    // minListingYear(){
    //   let minBoatYear = null;
    //   if( this.listingsLoaded ){
    //       let minYear = this.listings.reduce( (prev, curr) => prev.ModelYear < curr.ModelYear ? prev : curr);
    //       minBoatYear = minYear.ModelYear 
    //   } else {
    //     minBoatYear = 1900
    //   }
    //   console.log(minBoatYear)
    //   return minBoatYear
    // }
  },
  methods: {
    filterListingsByMake(listings) {
      return listings.filter( listing => listing.meta.ketch_boat_make[0].toLowerCase().indexOf(this.make.toLowerCase()) > -1)
    },
    filterListingsByYear(listings){
      return listings.filter(listing => (listing.meta.ketch_boat_model_year[0] >= this.yearMin && listing.meta.ketch_boat_model_year[0] <= this.yearMax) ? listing : '')
    },
    filterListingsByLength(listings){
      return listings.filter(listing => (parseInt(listing.meta.ketch_boat_length[0]) >= (this.lengthMin * 0.3048) && parseInt(listing.meta.ketch_boat_length[0]) <= (this.lengthMax * 0.3048)) ? listing : '')
    },
    filterListingsByPrice(listings){
      return listings.filter(listing => (parseInt(listing.meta.ketch_boat_price[0]) >= this.priceMin && parseInt(listing.meta.ketch_boat_price[0]) <= (this.priceMax)) ? listing : '')
    },
    filterListingsByCategory(listings) {
      if (this.category) {
        return listings.filter( listing => listing.meta.ketch_boat_class_code[0].indexOf(this.category) > -1)
      } else {
        return listings
      }
      
    },
    filterListingsByCondition(listings) {
      if ( this.condition === '' ) {
        return listings
      } else {
        return listings.filter( listing => listing.meta.ketch_sale_class_code[0].toLowerCase().indexOf(this.condition) > -1)
      }
    },
    filteredListingsAll() {
      this.filteredListings = this.filterListingsByPrice(this.filterListingsByLength(this.filterListingsByYear(this.filterListingsByMake(this.filterListingsByCategory(this.filterListingsByCondition(this.listings))))));
      // set session storage
      if (this.make) {
        // console.log("this.make")
        // console.log(this.make)
        sessionStorage.setItem("ketch_make", this.make)
      }
      
      sessionStorage.setItem("ketch_year_min", this.yearMin)
      sessionStorage.setItem("ketch_year_max", this.yearMax)
      sessionStorage.setItem("ketch_length_min", this.lengthMin)
      sessionStorage.setItem("ketch_length_max", this.lengthMax)
      sessionStorage.setItem("ketch_price_min", this.priceMin)
      sessionStorage.setItem("ketch_price_max", this.priceMax)
      if (this.category ) {
        sessionStorage.setItem("ketch_category", this.category)
      }
      if (this.condition) {
        sessionStorage.setItem("ketch_condition", this.condition)
      }
      // console.log("filter")
    },
    resetFilters(){
      this.make = '';
      this.$refs.autoComplete.clearSearch();
      this.year = [this.minYear, new Date().getFullYear()];
      this.minYear = this.minYearAllowed;
      this.maxYear = this.maxYearAllowed;
      this.lengthMin = this.lengthMinAllowed;
      this.lengthMax = this.lengthMaxAllowed;
      this.priceMin = this.minPriceAllowed;
      this.priceMax = this.maxPriceAllowed;
      this.category = null;
      this.condition = '';
      this.filteredListings = this.listings;
      // reset session storage
      sessionStorage.removeItem("ketch_make")
      sessionStorage.removeItem("ketch_year_min")
      sessionStorage.removeItem("ketch_year_max")
      sessionStorage.removeItem("ketch_length_min")
      sessionStorage.removeItem("ketch_length_max")
      sessionStorage.removeItem("ketch_price_min")
      sessionStorage.removeItem("ketch_price_max")
      sessionStorage.removeItem("ketch_category")
      sessionStorage.removeItem("ketch_condition")
    },
    updateMake(data) {
      this.make = data;
    },
    updateYearMin(e) {
      //console.log(e.target.value)
      const value = e.target.value;

      if (value < this.minYearAllowed ) {
        this.yearMin = this.minYearAllowed
      }
      if (value > this.maxYearAllowed ) {
        this.yearMin = this.maxYearAllowed 
      }
    },
    updateYearMax(e) {
      //console.log(e.target.value)
      const value = e.target.value;

      if (value < this.minYearAllowed ) {
        this.yearMax = this.minYearAllowed 
      }
      if (value > this.maxYearAllowed ) {
        this.yearMax = this.maxYearAllowed 
      }
    },
    updateLengthMin(e) {
      //console.log(e.target.value)
      const value = e.target.value;

      if (value < this.lengthMinAllowed ) {
        this.lengthMin = this.lengthMinAllowed
      }
      if (value > this.lengthMaxAllowed ) {
        this.lengthMin = this.lengthMaxAllowed
      }
    },
    updateLengthMax(e) {
      //console.log(e.target.value)
      const value = e.target.value;

      if (value < this.lengthMinAllowed ) {
        this.lengthMax = this.lengthMinAllowed
      }
      if (value > this.lengthMaxAllowed ) {
        this.lengthMax = this.lengthMaxAllowed
      }
    },
    updatePriceMin() {
      const value = this.priceMin;

      if (value < this.minPriceAllowed ) {
        this.priceMin = this.minPriceAllowed
      }
      if (value > this.maxPriceAllowed ) {
        this.priceMin = this.maxPriceAllowed
      }
    },
    updatePriceMax() {
      const value = this.priceMax;

      if (value < this.minPriceAllowed ) {
        this.priceMax = this.minPriceAllowed 
      }
      if (value > this.maxPriceAllowed ) {
        this.priceMax = this.maxPriceAllowed 
      }
    },
    closeDropdownMake() {
      console.log(this)
      this.$refs.dropdownMake.hide(true);
    },
    closeDropdownYear() {
      this.$refs.dropdownYear.hide(true);
    },
    closeDropdownLength() {
      this.$refs.dropdownLength.hide(true);
    },
    closeDropdownPrice() {
      this.$refs.dropdownPrice.hide(true);
    },
    closeDropdownCategory() {
      this.$refs.dropdownCategory.hide(true);
    },
    closeDropdownCondition() {
      this.$refs.dropdownCondition.hide(true);
    },
  },
  mounted() {
    this.$root.$on('bv::dropdown::hide', () => {
      this.filteredListingsAll;
      console.log(this.filteredListingsAll());
      //console.log('Dropdown is about to be hidden', bvEvent)
    })
  },
  created(){
    this.spinnerDisplay = true;

    // console.log("hello from vue")

    // testing
    // const url = 'http://localhost:8888/wp-json/wp/v2/ketch_boat_listings?per_page=100'
  
    const url = '/wp-json/wp/v2/ketch_boat_listings?per_page=100'

  axios.get(url)
    .then( res => {
      let promises = [];
      let boats = [];
     
      for ( let i = 0; i < res.headers['x-wp-totalpages']; i++) {
        promises.push(
          axios.get(`${url}&page=${i + 1}`)
          .then( res => {
           boats.push(res.data)
          })
        )
      }
      Promise.all(promises).then( ()=> {
        return [].concat.apply([], boats);
      })
      .then( res => {
        // console.log(res)
        // JSON parse images
        res.forEach( listing => {
          listing.meta.ketch_boat_images = JSON.parse(listing.meta.ketch_boat_images[0])
        })
        // console.log(res)
        this.listings = res;
        this.filteredListings = this.listings;
        // set listingsLoaded to true
        this.listingsLoaded = true;  
        //populate category search
        let boatCategoriesAll = [];
        res.forEach( r => r.meta.ketch_boat_class_code[0].split(",")
                        .forEach( b => boatCategoriesAll.push(b)))
        // console.log(boatCategoriesAll)
        let boatCategories = [...new Set(boatCategoriesAll)]
        // console.log(boatCategories)
        boatCategories.forEach( cat => this.categoryOptions.push({
                                            text: cat,
                                            //value: cat.toLowerCase(),
                                            value: cat,
                                            //num: boatCategoriesAll.filter((v) => v === cat).length
                                            }) )
      // Boat make
      let makeList = [];

      res.forEach( r => {
        if (!makeList.includes(r.meta.ketch_boat_make[0])) {
          makeList.push(r.meta.ketch_boat_make[0])
        }
      })
      this.makeList = makeList
      // console.log(makeList)

      })

      .then( ()=> {
        if (sessionStorage.getItem("ketch_make") !== null) {
          this.make = sessionStorage.getItem("ketch_make");
        }
        if (sessionStorage.getItem("ketch_year_min") !== null) {
          this.yearMin = parseInt(sessionStorage.getItem("ketch_year_min"));
        }
        if (sessionStorage.getItem("ketch_year_max") !== null) {
          this.yearMax = parseInt(sessionStorage.getItem("ketch_year_max"));
        }
        if (sessionStorage.getItem("ketch_length_min") !== null) {
          this.lengthMin = parseInt(sessionStorage.getItem("ketch_length_min"));
        }
        if (sessionStorage.getItem("ketch_length_max") !== null) {
          this.lengthMax = parseInt(sessionStorage.getItem("ketch_length_max"));
        }
        if (sessionStorage.getItem("ketch_price_min") !== null) {
          this.priceMin = parseInt(sessionStorage.getItem("ketch_price_min"));
        }
        if (sessionStorage.getItem("ketch_price_max") !== null) {
          this.priceMax = parseInt(sessionStorage.getItem("ketch_price_max"));
        }
        if (sessionStorage.getItem("ketch_category") !== null) {
          this.category = sessionStorage.getItem("ketch_category");
        }  
        if (sessionStorage.getItem("ketch_condition") !== null) {
          this.condition = sessionStorage.getItem("ketch_condition");
        } 
        
        this.filteredListingsAll();

        //set spinner to false
        this.spinnerDisplay = false;
  
      })

      
    })
   

          
  //     })
      // .then(
      //   ()=>{
      //     // if( this.listingsLoaded ){
      //         let minYear = this.listings.reduce( (prev, curr) => prev.ModelYear < curr.ModelYear ? prev : curr);
      //         this.minYear = minYear.ModelYear 
      //         this.year[0] = minYear.ModelYear 
      //     // } else {
      //     //   this.minYear = 1900
      //     //   this.year[0] = 1900
      //     // }
      //     console.log(this.minYear)
      //   }
      // )
      .catch( err => console.log(err))

      // console.log(this.listings)
      
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/global.scss';



  #home-container {
    background-color: #f9fafb;
    min-height: 100vh;

    //bootstrap styles
    .form-control {
        display: block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    input {
      overflow: visible;
      margin: 0;
    }

    label {
      display: inline-block !important;
      margin-bottom: 0.5rem !important;
    }

    .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent !important;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    //bootstrap styles

    label {
      color: #fff;
    }

    #filterBtn {
    font-size: 1.1rem !important;
    font-weight: 700;
    background-color: lighten($blue, 10) !important;
    border: transparent;
    border-bottom: 1px solid #f1f1f1;
    border-radius: 0;
    color: $white !important;
    display: flex;
    justify-content: center;
    position: relative;

    span {
      color: $white;
    }

    &:hover {
      color: $white;
      background-color: $blue !important;
      border: transparent !important;
      border-bottom: 1px solid #f1f1f1;
    }
    
    &:focus {
      color: $white;
      background-color: lighten($blue, 10) !important;
      border: transparent;
      border-bottom: 1px solid #f1f1f1;
      box-shadow: none;
    }

    &:active {
      color: $white !important;
    }
  }

  .container {
    position: relative;
  }
  
  .when-opened, .when-closed {
    position: absolute;
    right: 15px;
  }

  /* .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  } */

  .collapsed {
    .container {
      .when-opened {
        display: none;
      }
    }
  }

  .not-collapsed {
    .container {
      .when-closed {
        display: none;
      }
    }
  }

  .filter-row {
    background-color: #f7f7f7 !important;
  }

  .filter-row .form-control{
    border-radius: 0;
    border-color: $ltgray;
    font-weight: 300;
    margin-bottom: 0;
    min-height: auto !important;
  }

  .filter-row .btn{
    border-radius: 0 !important;
  }

  .filter-row {
    label {
      color: $blue;
      font-weight: 300;
    }

    .btn-reset {
      background-color: $blue !important;
      border: 1px solid $blue !important;
      color: $white !important;

      &:hover {
        background-color: lighten($blue, 15) !important;
        border: 1px solid $blue !important;
        color: $white !important;
      }
    }

    .btn-update {
      background-color: $gold !important;
      border: 1px solid $gold !important;
      color: $blue !important;

      &:hover {
        background-color: lighten($gold, 15) !important;
        border: 1px solid $gold !important;
        color: $blue !important;
      }
    }
    
  }

  .dash {
    display: flex;
    align-items: center;
    font-size: .75em;
    color: $blue;
  }

  .doneBtn {
      display: none;
    }
  }


  @media (min-width: 976px) {
    #home-container {
      .doneBtn {
        display: inline-block;
      }
    } 
    
  }
  

</style>
